<template>
	<div class="homePage-project-nijian">
		<el-row>
			<el-col class="en">
				PROJECTS PLANNED FOR CONSTRUCTION
			</el-col>
			<el-col class="ch">
				<img src="/img/nijian.png" draggable="false"/>
			</el-col>
			<el-col>
				<div class="projectList">
					<div v-for="item in pList" class="project" @click="openProject(item)">
						<img src='/file/sss.png' draggable="false"></img>
						<div class="name">{{item.name}}</div>
						<div class="viewCount"><i class="el-icon-view"></i> 2626</div>
					</div>
				</div>
			</el-col>
			<el-col>
				<el-button type="text" class="more" @click="goProject('nijian')">MORE <i class="el-icon-right"></i> </el-button>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import projectList from '@/assets/project.js'
	
	export default {
		data() {
			return {
				pList:[]
			}
		},
		created() {
			this.pList = projectList.nijian.slice(0, 4)
		},
		methods: {
			goProject(val) {
				this.$emit('setDefaultactive', 'project')
				this.$router.push({
					path: 'project',
					query: {
						name: val
					}
				})
			},
			openProject(val) {
				this.$emit('setDefaultactive', 'project')
	
				this.$router.push({
					path: 'project',
					query: {
						name: 'nijian',
						id: val.id
					}
				})
			}
		}
	}
</script>

<style lang="scss">
	.homePage-project-nijian {
		height: 500px;
		text-align: center;

		.en {
			padding-top:70px;
			font-size: 36px;
			color: #D9D3D3;
			padding-bottom: 10px;
		}

		.ch {
			color: #323232;
			font-size: 20px;
			// margin-bottom: 40px;
			font-weight: bold;
		}

		.projectList {
			width: 1440px;
			margin: 40px auto;
			height: 230px;

			.project {
				margin: 0px 12px;
				width: 336px;
				height: 190px;
				float: left;
				color: #000;
				cursor: pointer;

				img {
					border-radius: 8px;
					width: 100%;
					height: 100%;
				}

				.name {

					background-color: #F3EFEC;
					// background: -webkit-linear-gradient(top, #87878711, #35353566, #00000066);
					opacity: 0.99;
					font-size: 16px;
					text-align: left;
					height: 55px;
					line-height: 55px;
					margin-top: -10px;
					padding-left: 10px;
					border-bottom-right-radius: 8px;
					border-bottom-left-radius: 8px;
				}

				.viewCount {
					opacity: 0.99;
					height: 55px;
					line-height: 55px;
					margin-top: -55px;
					margin-right: 10px;
					text-align: right;

					i {
						font-weight: bold;
					}
				}
			}


			.project:hover {
				color: #fff;
				transform: scale(1.06);
				transition:0.3s;
				
				.name {
					background-color: #7D3811;
				}
			}
		}

		.more {
			color: #7D3811;

		}
	}
</style>